import React from "react";

export const MODAL_PORTAL_ID = "modal-portal";

export function ModalPortal() {
  return <div id={MODAL_PORTAL_ID} />;
}
